import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react'
import { renderField } from '../utils'
import {
  CHART_DATA_SOURCE,
  CHART_INSIGHT_MODE
} from '../../chartConfigurationsV2'
import { NumberInput } from './NumberInput'
import { THEME_COLOR_SWATCH } from 'utils/constants'
import Modal from 'components/Modal';
import InfoBox from 'components/InfoBox';
import { VuiAccordion } from '@topkamera/viso-ui';
import { Select } from './Select'
import { MultiSelect } from './MultiSelect'
import { VuiInfo } from '@topkamera/viso-ui';
import { generateDataSourceFields, dashboardForm } from '../utils'

export const DataSource = ({
  onChange = (val) => null,
  color,
  charts,
  values
}) => {

  const formProps = { color: color, fieldsGap: 8 }

  const fields = useMemo(
    () => generateDataSourceFields({ charts, data: values || {}, color }),
    [charts, values]
  )

  const lastSerializedDataRef = useRef(null)

  const onFormChange = useCallback((data) => {
    const serialized = JSON.stringify(data)
    if (lastSerializedDataRef.current === serialized) return

    lastSerializedDataRef.current = serialized

    onChange(data)
  }, [onChange])

  return (
    <>
      {dashboardForm({
        description: '',
        fields,
        onFormChange,
        formProps
      })}
    </>
  )
}
